import { NavigationError } from '@angular/router';

export const handleNavigationError = (e: NavigationError) => {
  if (e.error.message.includes('Failed to fetch dynamically imported module')) {
    document.location.reload();
  }
};
